// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Modal, ModalSize } from '@/components';
import { StyledButtonsWrapper, StyledTitleModal } from '../Styled';
import { Button } from '@/ui';

// Models
import { IPartnerProfile } from '@/models/partners.model';

type THideModal = {
  isOpened: boolean;
  closeModal: () => void;
  currentUserDetails: IPartnerProfile;
  handleHidePartner: () => Promise<void>;
};

const HideModal = ({ isOpened, closeModal, currentUserDetails, handleHidePartner }: THideModal) => {
  const { t } = useTranslation(['usersList']);
  const userStatusChangeText = currentUserDetails?.hidden ? 'users_list_show_user' : 'users_list_hide_user';
  const userStatusChangeButtonText = currentUserDetails?.hidden ? 'users_list_show_button' : 'users_list_hide_button';

  return (
    <Modal visible={isOpened} onCancel={closeModal} size={ModalSize.LARGE}>
      <StyledTitleModal>
        {t(userStatusChangeText, {
          name: currentUserDetails?.title,
        })}
      </StyledTitleModal>
      <StyledButtonsWrapper>
        <Button onClick={closeModal} type="primary">
          {t('users_list_back')}
        </Button>
        <Button onClick={handleHidePartner} type="text">
          {t(userStatusChangeButtonText)}
        </Button>
      </StyledButtonsWrapper>
    </Modal>
  );
};

export default HideModal;
